import React, { useState } from 'react';

export default function PartnerCard({ partner, hoverColor = "fuchsia", fallbackIcon: FallbackIcon }) {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const hoverClasses = {
    fuchsia: "hover:border-fuchsia-200 hover:bg-fuchsia-50/30",
    lime: "hover:border-lime-200 hover:bg-lime-50/30",
    amber: "hover:border-amber-200 hover:bg-amber-50/30",
    indigo: "hover:border-indigo-200 hover:bg-indigo-50/30",
  };

  const iconColors = {
    fuchsia: "text-fuchsia-400",
    lime: "text-lime-500",
    amber: "text-amber-500",
    indigo: "text-indigo-400",
  };

  const Content = () => (
    <>
      {partner.logo && !imageError ? (
        <div className="relative h-12 w-full flex items-center justify-center mb-2">
          {!imageLoaded && (
            <div className="absolute inset-0 flex items-center justify-center">
              <FallbackIcon className={`h-10 w-10 ${iconColors[hoverColor]} opacity-30`} />
            </div>
          )}
          <img src={partner.logo} alt={partner.name} className={`h-12 w-auto object-contain transition-opacity ${imageLoaded ? 'opacity-100' : 'opacity-0'}`} onLoad={() => setImageLoaded(true)} onError={() => setImageError(true)} />
        </div>
      ) : (
        <div className="h-12 w-12 mb-2 rounded-lg bg-gradient-to-br from-zinc-100 to-zinc-200 flex items-center justify-center">
          <FallbackIcon className={`h-6 w-6 ${iconColors[hoverColor]}`} />
        </div>
      )}
      <span className="text-sm font-medium text-zinc-700 leading-tight">{partner.name}</span>
    </>
  );

  const baseClasses = `bg-white rounded-xl p-4 shadow-sm border border-zinc-100 hover:shadow-md transition-all flex flex-col items-center justify-center text-center min-h-[120px] ${hoverClasses[hoverColor]}`;

  if (partner.url) {
    return (
      <a href={partner.url} target="_blank" rel="noopener noreferrer" className={`${baseClasses} cursor-pointer`}>
        <Content />
      </a>
    );
  }

  return (
    <div className={baseClasses}>
      <Content />
    </div>
  );
}
